import React from 'react';
import { MailIcon, PhoneIcon, BriefcaseIcon, CpuIcon, LinkedinIcon, DollarSignIcon, UsersIcon, TagsIcon, ClockIcon } from 'lucide-react';
export function EnrichmentFields() {
  return <section className="py-24 bg-slate-50" data-id="element-4347">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4348">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4349">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4350">
            What our local business contact{' '}
            <span className="text-blue-600" data-id="element-4351">enrichment</span> adds to every
            record
          </h2>
          <p className="text-xl text-slate-600" data-id="element-4352">
            Turn basic local business names into complete, actionable profiles
            with 50+ enriched data fields.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4353">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4354">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4355">
              <MailIcon className="w-6 h-6" data-id="element-4356" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4357">
              Owner emails
            </h3>
            <p className="text-slate-600" data-id="element-4358">
              Verified email addresses for local business owners and
              decision-makers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4359">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4360">
              <PhoneIcon className="w-6 h-6" data-id="element-4361" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4362">
              Direct phones
            </h3>
            <p className="text-slate-600" data-id="element-4363">
              Direct dial and mobile numbers for key local business contacts.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4364">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4365">
              <BriefcaseIcon className="w-6 h-6" data-id="element-4366" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4367">
              Job titles
            </h3>
            <p className="text-slate-600" data-id="element-4368">
              Accurate roles like Founder, GM, or Marketing Director.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4369">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4370">
              <CpuIcon className="w-6 h-6" data-id="element-4371" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4372">
              Tech stack
            </h3>
            <p className="text-slate-600" data-id="element-4373">
              Technologies used by the local business (Shopify, Toast,
              Mindbody).
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4374">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4375">
              <LinkedinIcon className="w-6 h-6" data-id="element-4376" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4377">
              Social profiles
            </h3>
            <p className="text-slate-600" data-id="element-4378">
              LinkedIn, Instagram, and Facebook profiles for the business and
              owners.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4379">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4380">
              <DollarSignIcon className="w-6 h-6" data-id="element-4381" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4382">
              Revenue estimates
            </h3>
            <p className="text-slate-600" data-id="element-4383">
              Estimated annual revenue to help qualify your local business
              leads.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4384">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4385">
              <UsersIcon className="w-6 h-6" data-id="element-4386" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4387">
              Employee count
            </h3>
            <p className="text-slate-600" data-id="element-4388">
              Accurate company size metrics for better segmentation.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4389">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4390">
              <TagsIcon className="w-6 h-6" data-id="element-4391" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4392">
              Business categories
            </h3>
            <p className="text-slate-600" data-id="element-4393">
              Primary and secondary industry classifications.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4394">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4395">
              <ClockIcon className="w-6 h-6" data-id="element-4396" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4397">
              Operating hours
            </h3>
            <p className="text-slate-600" data-id="element-4398">
              Daily open and close times from their local business profile.
            </p>
          </div>
        </div>
      </div>
    </section>;
}